export default __webpack_public_path__ + "425399f81e4ce7cbd967685402ba0260.woff";